import PropTypes from 'prop-types'
import React, {Fragment} from 'react'
import {css} from 'glamor'
import {colors} from '../styles'

const style = {
  address: css({
    color: colors.gray46
  })
}

const Address = ({address, inline, ...props}) => {
  return (
    <div itemScope="" itemType="http://schema.org/LocalBusiness" {...props}>
      <div
        itemProp="address"
        itemScope=""
        itemType="http://schema.org/PostalAddress"
        {...style.address}
      >
        <span itemProp="streetAddress">{address.Address1}</span>
        {inline ? address.Address2 ? ' ' : ', ' : <br />}
        {address.Address2 && (
          <Fragment>
            <span itemProp="streetAddress">{address.Address2}</span>
            {inline ? ', ' : <br />}
          </Fragment>
        )}
        <span itemProp="addressLocality">{address.City}</span>,{' '}
        <span itemProp="addressRegion">{address.State}</span>{' '}
        <span itemProp="postalCode">{address.Zip}</span>
      </div>
    </div>
  )
}

Address.propTypes = {
  address: PropTypes.shape({
    Address1: PropTypes.string.isRequired,
    Address2: PropTypes.string,
    City: PropTypes.string.isRequired,
    State: PropTypes.string.isRequired,
    Zip: PropTypes.string.isRequired
  }).isRequired,
  inline: PropTypes.bool
}

export default Address
